import { MEASURE_UNIT_LENGTH } from '@/features/measure/consts/unit'
import i18n from '@/i18n'

const { m, cm } = MEASURE_UNIT_LENGTH

type OptionType = {
  label: string
  value: MEASURE_UNIT_LENGTH
}

const localeData: any = {
  en: {
    [m]: 'm',
    [cm]: 'cm',
  },
  de: {
    [m]: 'm',
    [cm]: 'cm',
  },
}

const locale = (code: string) => {
  return localeData[code]
}

export const getLengthUnits = (): OptionType[] => {
  const code = i18n.language

  return [
    {
      label: locale(code).m,
      value: m,
    },
    {
      label: locale(code).cm,
      value: cm,
    },
  ]
}

export const lengthUnitsMap = getLengthUnits().reduce((acc: any, curr) => {
  const { value } = curr

  return acc.set(value, curr)
}, new Map())
